var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.507,
    height: 28.507,
    viewBox: "0 0 28.507 28.507",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2401",
    "data-name": "Group 2401",
    transform: "translate(0.643 0.644)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_17671_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_17674_",
    cx: 10.582,
    cy: 10.582,
    r: 10.582,
    transform: "translate(0 7.39) rotate(-20.439)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_17673_",
    x2: 8.304,
    y2: 8.304,
    transform: "translate(9.484 9.472)",
    fill: "none",
    stroke: "#ff1a00",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_17672_",
    y1: 8.304,
    x2: 8.304,
    transform: "translate(9.484 9.472)",
    fill: "none",
    stroke: "#ff1a00",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.65cce40dbc8d3123d9fae207fb410bae.svg";
export { ForwardRef as ReactComponent };